function getObjectCoordinates(geoObject, coordinates, map) {
  const projection = geoObject.options.get("projection");
  const globalPixels = projection.toGlobalPixels(coordinates, map.getZoom());
  const pageCoordinates = map.converter.globalToPage(globalPixels);
  return {
    lat: coordinates[0],
    lng: coordinates[1],
    pageX: pageCoordinates[0],
    pageY: pageCoordinates[1]
  };
}
export {
  getObjectCoordinates as default
};
//# sourceMappingURL=getObjectCoordinates.js.map
